(ns ycweb.app.admin.tasks.views.kanban
  (:require
   #?@(:clj
       [[clj-time.core :as dt]
        [clj-time.coerce :as dtc]]
       :cljs
       [[cljs-time.core :as dt]
        [cljs-time.coerce :as dtc]])
   [inflections.core :as inflections]
   [rum.core :as rum]
   [ycweb.app.admin.tasks.common :as yaatc.common]
   [ycweb.app.admin.tasks.forms.devtask]
   [ycweb.app.admin.tasks.forms.incident]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.grid :as grid]
   [ycweb.components.toaster :as toaster]
   [ycweb.util.core :as u]
   [ycweb.util.date :as ud]
   [ycweb.util.urlstate :as urlstate]))

(defn calculate-background [c]
  (let [dt
        (dtc/to-date-time (or (u/presence (:airtable/date-modified c)) (u/presence (:airtable/date-created c))))]
    (cond
      (nil? dt) "#c0c0c0"

      (dt/before? dt (dt/minus (dt/now) (dt/months 3)))
      "#ee7f6d"

      (dt/before? dt (dt/minus (dt/now) (dt/months 1)))
      "#ffcb76"

      (dt/before? dt (dt/minus (dt/now) (dt/weeks 2)))
      "#ffe06b"

      :else
      "#a0d468")))

(defn calculate-hover [c]
  (let [dt
        (dtc/to-date-time (or (u/presence (:airtable/date-modified c)) (u/presence (:airtable/date-created c))))]
    (cond
      (nil? dt) "#c0c0c0"

      (dt/before? dt (dt/minus (dt/now) (dt/months 3)))
      "#d03a37"

      (dt/before? dt (dt/minus (dt/now) (dt/months 1)))
      "#f29d0f"

      (dt/before? dt (dt/minus (dt/now) (dt/weeks 2)))
      "#f2c105"

      :else
      "#7ead4a")))

(rum/defcs render-task-cell < rum/reactive (cmn/local {:hover? false} ::local) [s app-atom lookup-atom c]
  (let [assigned
        (map
          (fn [assigned-uuid]
            (cmn/curact lookup-atom [:user assigned-uuid]))
          (keys (:task/assigned c)))

        team (cmn/curact lookup-atom [:task.team (get-in c [:task/team :ent/uuid])])
        requestor (cmn/curact lookup-atom [:user (get-in c [:task/requestor :ent/uuid])])
        task-stream (cmn/curact lookup-atom [:task.stream (get-in c [:task/stream :db/ident])])
        task-type (cmn/curact lookup-atom [:task.type (get-in c [:task/type :db/ident])])
        budget (cmn/curact lookup-atom [:times (:task/budget c)])
        time-spent (cmn/curact lookup-atom [:times (:task/time-spent c)])
        dev-status (cmn/curact lookup-atom [:task.dev-status (get-in c [:task/dev-status :db/ident])])

        hover? (:hover? (rum/react (::local s)))]

    [:div {:style {:position "relative"}}
     [:div
      (merge
        (urlstate/href-props app-atom
          "tasks" nil
          (merge
            (cmn/screen-params app-atom)
            {:task-uuid (str (:ent/uuid c))}))
        {:style
         {:cursor "pointer"
          :margin-bottom "5px"
          :padding "10px"
          :width "200px"
          :overflow-wrap "break-word"
          :background-color (calculate-background c)
          :border (if hover? (str "2px solid " (calculate-hover c)) (str "2px solid " (calculate-background c)))
          :border-radius "5px"
          :font-size "12px"  :z-index 1
          :box-shadow "0 4px 4px -4px rgb(0 0 0 / 20%)"}
         :on-mouse-over #(swap! (::local s) assoc :hover? true)
         :on-mouse-out #(swap! (::local s) assoc :hover? false)
         :draggable "true"
         :on-drag-start
         (fn [e]
           #?(:cljs
              (do
                (swap! (::local s) assoc :hover? false)
                (.setData (.-dataTransfer ^js/DragEvent e) "type" "task")
                (.setData (.-dataTransfer ^js/DragEvent e) "uuid" (str (:ent/uuid c))))))})
      [:div
       {:class (u/bem :flex-grid-group [:flush-force :align-left])}
       [:div
        {:class (u/bem :flex-grid-block [:m-1-6 :m-order-02])}
        [:div.flex-grid-content
         [:div
          {:style {:font-size "14px"}}
          (cond
            (= (:db/ident task-stream) :task.stream/bug)
            "\uD83D\uDC1E"

            (= (:db/ident task-stream) :task.stream/incident)
            "\uD83D\uDEA8"

            (= (:db/ident task-stream) :task.stream/project)
            "\uD83D\uDE80"

            (= (:db/ident task-stream) :task.stream/improvement)
            "\uD83E\uDD84"

            :else
            "\uD83E\uDD37")]]]
       [:div
        {:class (u/bem :flex-grid-block [:m-5-6 :order-01])}
        [:div.flex-grid-content
         [:p
          {:class (u/bem :yc-paragraph [:small-force :flush])}
          [:b (:ent/display-name c)]]]]]

      [:p.u-margin-bottom-8
       {:class (u/bem :yc-paragraph [:small-force :flush])}
       (if budget
         (:ent/display-name budget)
         "No Budget")
       (when
         (and
           time-spent
           (contains?
             #{:task.dev-status/pr :task.dev-status/checking :task.dev-status/done :task.dev-status/archived}
             (:db/ident dev-status)))
         (str " - Spent " (:ent/display-name budget)))]

      (when-not (empty? assigned)
        [:div
         {:style
          {:background-color "#C2F5E9"
           :border-radius "10px"
           :padding "2px 10px 2px 10px"
           :margin-bottom "2px"}}
         (map
           (fn [a]
             [:div
              "A: "
              [:span (yaatc.common/user-image a {:size 16})]
              (:ent/display-name a)])
           assigned)])

      (when requestor
        [:div
         {:style
          {:background-color "#D0F0FD"
           :border-radius "10px"
           :padding "2px 10px 2px 10px"
           :margin-bottom "2px"}}
         "R: "
         [:span (yaatc.common/user-image requestor {:size 16})]
         (:ent/display-name requestor)])

      (when task-type
        [:div
         {:style
          {:background-color (:ent/color task-type)
           :border-radius "10px"
           :padding "2px 10px 2px 10px"
           :margin-bottom "2px"}}
         (:ent/display-name task-type)])

      (when task-stream
        [:div
         {:style
          {:background-color (:ent/color task-stream)
           :border-radius "10px"
           :padding "2px 10px 2px 10px"
           :margin-bottom "2px"}}
         (:ent/display-name task-stream)
         (when (= (:db/ident task-stream) :task.stream/project)
           (str ": " (:ent/display-name (:task/project c))))])

      (when (:task/date-deadline c)
        [:div
         {:style
          {:background-color "#FFDCE5"
           :border-radius "10px"
           :padding "2px 10px 2px 10px"
           :margin-bottom "2px"}}
         "Deadline: " (ud/format-date (:task/date-deadline c) "d MMMM YYYY")])]]))

(rum/defcs build-kanban-column < rum/reactive (cmn/local false ::drag?) [s app-atom lookup-atom [group-details tasks]]
  (let [drag-atom (::drag? s)]
    [:div
     {:class (u/bem :flex-grid-block [:fluid])
      :on-drag-over (fn [e] #?(:cljs (.preventDefault e)) (reset! drag-atom true) true)
      :on-drag-leave (fn [e] #?(:cljs (.preventDefault e)) (reset! drag-atom false) true)
      :on-drop
      (fn [e]
        (reset! drag-atom false)
        #?(:cljs
           (let [uid (u/uuid (.getData (.-dataTransfer e) "uuid"))]
             (toaster/open-toast app-atom :processing "Saving" {})
             (grid/dispatch-action app-atom :admin.tasks/assign-dev-status
               {:task-uuid uid :group group-details}))))
      :style {:max-width "280px" :padding "10px 6px"}}
     [:div.flex-grid-content
      {:style
       {:padding "12px"
        :background-color (if (rum/react drag-atom) "#dadada" "#f2f2f2")
        :border-radius "8px"}}
      [:p {:class (u/bem :yc-paragraph [:small])}
       [:b (:ent/display-name group-details)]]
      #_[:div.u-text-center.u-margin-top-8.u-margin-bottom-8
         (buttons/button-web "Add task"
           {:style :secondary-noborder
            :on-click #(grid/dispatch-action app-atom :admin.tasks/new-task group-details)
            :size :small
            :flat-style :flat
            :icon :plus
            :full true
            :class "button--rounded"})]
      [:div
       {:style {:height "750px" :overflow-y "scroll"}}
       (map #(render-task-cell app-atom lookup-atom %) tasks)]

      (when (pos? (count tasks))
        (let [[empties budgeted] (u/separate (comp (fnil zero? 0) :task/budget) tasks)
              [_ spent] (u/separate (comp (fnil zero? 0) :task/time-spent) tasks)
              number-of-empties (count empties)
              summary
              [[:li
                [:i {:class (u/bem :icon [:grid-small :is-dark :small :in-copy-left :inline])}]
                "Total: " (inflections/pluralize (count tasks) "Task")]
               (if (> number-of-empties 0)
                 [:li
                  [:i {:class (u/bem :icon [:error :is-dark :small :in-copy-left :inline])}]
                  "No budget: " (inflections/pluralize number-of-empties "Task")]
                 [:li
                  [:i {:class (u/bem :icon [:emoticon-happy :is-dark :small :in-copy-left :inline])}]
                  "All tasks budgeted"])
               [:li
                [:i {:class (u/bem :icon [:clock :is-dark :small :in-copy-left :inline])}]
                (str "Budgeted: " (apply + (map :task/budget budgeted)) " hours")]
               [:li
                [:i {:class (u/bem :icon [:success :is-dark :small :in-copy-left :inline])}]
                (str "Spent: " (apply + (map :task/time-spent spent)) " hours")]]]
          (into
            [:ul.u-no-list-bullets.u-margin-top-16
             {:class (u/bem :yc-list [:small :flush])}]
            summary)))]]))

(defmethod grid/action :admin.tasks/assign-dev-status [app-atom config]
  (let [process-atom (cmn/process-cursor app-atom)
        filter-atom (rum/cursor process-atom :filters)
        view (cmn/curact filter-atom :view)
        views (cmn/curact process-atom :view-list)
        view-config (get views view)
        grouping-key (keyword (get-in view-config [:kanban :config :grouping-key]))
        task-atom (rum/cursor-in process-atom [:tasks (:task-uuid config)])
        task @task-atom]

    #_(grid/dispatch-action app-atom :admin.tasks/save-task-view
        {:task (assoc task grouping-key (:group config))})))

(rum/defc kanban-dashboard < rum/reactive cmn/cursors [app-atom tasks]
  (let [process-atom (cmn/process-cursor app-atom)
        filter-atom (rum/cursor process-atom :filters)
        view (cmn/curact filter-atom :view)
        views (cmn/curact process-atom :view-list)
        lookup-atom (rum/cursor process-atom :lookup)
        view-config (get views view)
        grouping-key (keyword (get-in view-config [:kanban :config :grouping-key]))
        sort-order (get-in view-config [:kanban :config :sort-fn])

        filtered-tasks
        (yaatc.common/filter-tasks app-atom (vals tasks))

        grouped-tasks (sort-by #((or sort-order :ent/sort-order) (key %)) (group-by grouping-key filtered-tasks))]

    [:div
     [:div
      {:style {:overflow-x "scroll" :flex-wrap "nowrap"}
       :class (u/bem :flex-grid-group [:align-left :flush-force])}
      (map #(build-kanban-column app-atom lookup-atom %) grouped-tasks)]

     (toaster/loading-overlay app-atom :admin.tasks/list)]))